// extracted by mini-css-extract-plugin
module.exports = {"bold":"Word_bold__1svy_","color":"Word_color__3L6P0"};